import * as React from 'react'
import { ProductCard } from '@lacedltd/laced-components'
import { ProductCardProduct } from 'types/product'
import { useEnterKeyHandler, useLocale, useTranslation } from 'hooks'
import { withGrowthbook, formatPrice, tracking } from 'helpers'
import ProductPicture from '../ProductPicture'

const ProductRowItem: React.FC<ProductRowItemProps> = ({
  product: {
    style_code: styleCode,
    image_url: imageUrl,
    display_price_cents: displayPriceCents,
    formatted_display_price: formattedDisplayPrice,
    title,
    brand,
    category,
    colour,
    href
  }
}) => {
  const { t } = useTranslation()
  const handleEnterKey = useEnterKeyHandler()

  const priceString =
    formattedDisplayPrice || (t('shared.out_of_stock') as string)

  // Keeping formatPrice to get price without currency
  const clickProduct = () => {
    tracking.pushToDataLayer('productClick', {
      ecommerce: {
        click: {
          products: [
            {
              name: title,
              id: styleCode,
              price: formatPrice(displayPriceCents as number, {
                currencyCode: null,
                valueIsCents: true
              }),
              brand,
              category,
              variant: colour
            }
          ]
        }
      }
    })
  }

  const { localiseUrl } = useLocale()

  const imgComponent = (
    <ProductPicture
      className="product-card__img"
      title={title}
      src={imageUrl}
      lazyLoad
      width={442}
    />
  )

  return (
    <li className="product-card" data-testid="product-card" key={title}>
      <a
        href={localiseUrl(href)}
        tabIndex={0}
        className="product-card__inner"
        onClick={() => clickProduct()}
        onKeyDown={(e) => handleEnterKey(e, clickProduct)}
      >
        <ProductCard
          imageSource={imgComponent}
          brand={brand}
          title={title}
          price={priceString}
        />
      </a>
    </li>
  )
}

interface ProductRowItemProps {
  product: ProductCardProduct
}

export default ProductRowItem
